<template>
  <material-card
    color="success"
    title="Membros"
    text="Vendas realizadas"
    v-if="!loading"
  >
    <v-text-field
      v-model="search"
      append-icon="search"
      label="Buscar"
      single-line
      hide-details
    ></v-text-field>
    <template v-slot:loading>
      <v-progress-linear
        v-if="loading"
        height="2"
        color="cyan"
        indeterminate
      ></v-progress-linear>
    </template>
    <v-data-table
      dense
      light
      :headers="headers"
      :items="sales"
      :loading="loading"
      :rows-per-page-items="[100, 200, 300, 500]"
      :pagination.sync="pagination"
      :search="search"
      item-key="id"
      rows-per-page-text="Linhas por página"
      no-data-text="Não há vendas realizadas nesse período"
    >
      <template slot="headerCell" slot-scope="{ header }">
        <span
          class="subheading font-weight-light text-success text--darken-3"
          v-text="header.text"
        />
      </template>
      <template slot="items" slot-scope="{ item }">
        <td>{{ item.signedcontract_at | formatDate }}</td>
        <td>{{ item.uc }}</td>
        <td>{{ item.name }}</td>
        <td>{{ item.email }}</td>
        <td>{{ item.phone || "" }}</td>
        <td>{{ item.status | formatStatus }}</td>
        <td>{{ item.sale ? item.sale.status : item.status | formatStatus }}</td>
        <!-- <td>{{ item.status === 'DESQUALIFICAR' && item.bot_status?item.bot_status:'' }}</td> -->
        <td>
          {{
            item.sale && item.sale.status === "DESQUALIFICAR"
              ? item.sale.reason_desqualify
              : item.reason_desqualify
          }}
        </td>
        <td>
          {{
            item.sale
              ? item.sale.payment_competence === false
                ? ""
                : item.sale.payment_competence
              : ""
          }}
        </td>
        <!-- <td>{{ item.card_default }}</td> -->
      </template>
      <template v-slot:no-results>
        <v-alert :value="true" color="error" icon="warning"
          >Sua busca para "{{ search }}" não retornou resultados.</v-alert
        >
      </template>
      <template v-slot:pageText="items">
        Linhas {{ items.pageStart }} - {{ items.pageStop }} de
        {{ items.itemsLength }}
      </template>
    </v-data-table>
  </material-card>
</template>
<script>
import moment from "moment";
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  computed: {
    ...mapState("sales", ["loading", "sales"]),
    ...mapGetters(["loggedUser"]),
  },
  mounted() {
    if (this.sales.length <= 0) {
      let params = {};
      params.email_seller = this.loggedUser.email;
      this.resetFilter();

      if (this.loggedUser.email) {
        params.email_seller = this.loggedUser.email;
      } else {
        alert("Errox: Vendendor não identificado!");
      }
      if (this.cpf) {
        params.cpf = this.cpf;
      } else if (this.email) {
        params.email = this.email;
      } else if (this.status_filter && this.status_filter.status !== "") {
        params.status = this.status_filter.status;
      }

      params.dt_inicial = new Date().toISOString().substr(0, 10);
      params.dt_final = new Date().toISOString().substr(0, 10);

      this.getSalesByParams(params);
    }
  },
  data: () => ({
    pagination: {
      rowsPerPage: 200, // -1 for All",
    },
    search: "",
    headers: [
      {
        sortable: true,
        text: "Vendido em",
        value: "signedcontract_at",
      },
      {
        sortable: true,
        text: "U.C.",
        value: "uc",
      },
      {
        sortable: true,
        text: "Name",
        value: "name",
      },
      {
        sortable: true,
        text: "E-mail",
        value: "email",
      },
      {
        sortable: true,
        text: "Telefone",
        value: "phone",
      },
      {
        sortable: true,
        text: "Status",
        value: "status",
      },
      {
        sortable: true,
        text: "Qualificação",
        value: "sale.status",
      },
      {
        sortable: true,
        text: "Detalhes",
        value: "bot_status",
      },
      {
        sortable: true,
        text: "Pagamento em",
        value: "payment_competence",
      },
    ],
    status_list: [
      { status: "ATIVO", label: "ATIVO" },
      { status: "INATIVO", label: "INATIVO" },
      { status: "SENDED_PROPOSAL", label: "PROPOSTA ENVIADA" },
      { status: "QUALIFICAR", label: "QUALIFICAR" },
      { status: "DESQUALIFICAR", label: "DESQUALIFICADO" },
      { status: "REQUEST_PROPOSAL", label: "PROPOSTA SOLICITADA" },
      { status: "NOT_HOLDER", label: "NÃO É O TITULAR" },
      { status: "AGUARDANDO_CONTA", label: "AGUARDANDO CONTA" },
      { status: "MULTIPLAS_CONTAS", label: "MULTIPLAS INSTALAÇÕES" },
      {
        status: "AGUARDANDO_NRO_INSTALACAO",
        label: "AGUARDANDO NRO INSTALAÇÃO",
      },
      { status: "SEM_RETORNO", label: "SEM RETORNO" },
      { status: "QUALIFICAR_MANUALMENTE", label: "QUALIFICAR MANUALMENTE" },
      { status: "PAYMENT_METHOD_NOT_SELECTED", label: "SEM FORMA DE PAGTO" },
      { status: "SALE_PENDING", label: "AGUARDANDO VENDA" },
      { status: "waiting qualification", label: "QUALIFICAR" },
      { status: "canceling", label: "SOLICITOU CANCELAMENTO" },
    ],
  }),
  filters: {
    formatDate(value) {
      if (!value) return "";
      let d = moment(value).format("DD/MM/YYYY");
      return d;
    },
    formatStatus(status) {
      if (!status || status === "") return "";
      else if (status === "ATIVO") return "ATIVO";
      else if (status === "INATIVO") return "INATIVO";
      else if (status === "SENDED_PROPOSAL") return "PROPOSTA ENVIADA";
      else if (status === "QUALIFICAR") return "QUALIFICAR";
      else if (status === "DESQUALIFICAR") return "DESQUALIFICADO";
      else if (status === "REQUEST_PROPOSAL") return "PROPOSTA SOLICITADA";
      else if (status === "NOT_HOLDER") return "NÃO É O TITULAR";
      else if (status === "AGUARDANDO_CONTA") return "AGUARDANDO CONTA";
      else if (status === "MULTIPLAS_CONTAS") return "MULTIPLAS INSTALAÇÕES";
      else if (status === "AGUARDANDO_NRO_INSTALACAO")
        return "AGUARDANDO NRO INSTALAÇÃO";
      else if (status === "SEM_RETORNO") return "SEM RETORNO";
      else if (status === "QUALIFICAR_MANUALMENTE")
        return "QUALIFICAR MANUALMENTE";
      else if (status === "PAYMENT_METHOD_NOT_SELECTED")
        return "SEM FORMA DE PAGTO";
      else if (status === "SALE_PENDING") return "AGUARDANDO VENDA";
      else if (status === "waiting qualification") return "QUALIFICAR";
      else if (status === "canceling") return "SOLICITOU CANCELAMENTO";
      else if (status === "waiting reprocess") return "REPROCESSAMENTO";
      else if (status === "NAO_INTERESSADO") return "NÃO INTERESSADO";
      else if (status === "VALIDAR_CONTA") return "VALIDAR CONTA/UC";
      else return status;
    },
  },
  methods: {
    ...mapActions("sales", ["getSalesByParams", "resetFilter"]),
  },
};
</script>
